import React from 'react';
import clsx from 'clsx';

/*
 *
 * Browse available icons at: https://tabler.io/icons
 *
 */

type IconSize = 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl';

interface IconProps {

  name: string;

  variant?: 'outline' | 'filled';

  size?: IconSize;

  className?: string;

  'aria-label'?: string;
}

const sizeClassMap: Record<IconSize, string> = {
  xs: 'fs-xs',
  sm: 'fs-sm',
  base: 'fs-base',
  lg: 'fs-lg',
  xl: 'fs-xl',
  '2xl': 'fs-2xl',
  '3xl': 'fs-3xl',
};

export function Icon({
  name,
  variant = 'outline',
  size,
  className,
  'aria-label': ariaLabel,
}: IconProps) {
  const baseClass = variant === 'filled' ? 'tif' : 'ti';
  const sizeClass = size ? sizeClassMap[size] : undefined;

  return (
    <i
      className={clsx(baseClass, name, sizeClass, className)}
      /*
       * Icon fonts render using CSS :before content, which screen readers
       * would announce as gibberish. We hide decorative icons from assistive
       * technology. Only icons with explicit aria-label are announced.
       */
      aria-hidden={ariaLabel ? undefined : true}
      aria-label={ariaLabel}
      /*
       * When an icon has semantic meaning (aria-label), we need to tell
       * assistive technology to treat it as an image, not as text content.
       */
      role={ariaLabel ? 'img' : undefined}
    />
  );
}
